import numeral from 'numeral';

export default function shortenNumber(
  value: number | string | undefined,
  precision = 1,
  roundingFunction?: (value: number) => number
) {
  const format = `0.[${'0'.repeat(precision)}]a`;
  return numeral(value || 0)
    .format(format, roundingFunction)
    .toUpperCase();
}
